import React, { useState } from "react";
import axios from "axios";
import { Button, Check, ChevronDown, Globe01, MarkerPin01, Menu } from "@opendate-app/setlist";

import { toastSuccess, toastError } from "../../../shared/toastHelper";

const MarketingVenueSelector = ({
  teamId,
  teamMembership,
  csrfToken,
  onChange,
}) => {
  const [selectedVenueOwnershipId, setSelectedVenueOwnershipId] = useState(
    teamMembership.selected_marketing_venue_ownership_id || null
  );

  const venueOwnershipAccesses = teamMembership.venue_ownership_accesses || [];

  const findVenueById = (id) => (
    venueOwnershipAccesses.find((voa) => voa.venue_ownership_id === id)?.venue_ownership || null
  );

  const currentVenueOwnership = selectedVenueOwnershipId ? findVenueById(selectedVenueOwnershipId) : null;

  const handleVenueSelect = async (venueOwnershipId) => {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;

    try {
      await axios.patch(`/teams/${teamId}/team_memberships/${teamMembership.id}`, {
        team_membership: { selected_marketing_venue_ownership_id: venueOwnershipId },
      });

      setSelectedVenueOwnershipId(venueOwnershipId);
      toastSuccess(venueOwnershipId ? "Venue selection updated successfully" : "Now viewing all venues");
      if (onChange) onChange(venueOwnershipId ? findVenueById(venueOwnershipId) : null);
    } catch (_error) {
      toastError("Failed to update venue selection");
    }
  };

  const item = (id, label, icon, description) => ({
    key: id ?? "all",
    label,
    description,
    icon: selectedVenueOwnershipId === id ? Check : icon,
    onClick: () => handleVenueSelect(id),
  });

  const items = [
    item(null, "All Venues", Globe01, "View marketing resources from all venues"),
    ...(venueOwnershipAccesses.length > 0 ? [{ divider: true }] : []),
    ...venueOwnershipAccesses.map((voa) => item(voa.venue_ownership_id, voa.venue_ownership.venueable.name, MarkerPin01)),
  ];

  return (
    <Menu
      placement="bottom-end"
      header={<span style={{ fontSize: 12, fontWeight: 600, color: "var(--sl-text-tertiary)" }}>Marketing venue</span>}
      items={items}
      trigger={(
        <Button
          icon={currentVenueOwnership ? MarkerPin01 : Globe01}
          trailingIcon={ChevronDown}
          title={currentVenueOwnership ? `Current venue: ${currentVenueOwnership.venueable.name}` : "Viewing all venues"}
        >
          {currentVenueOwnership ? currentVenueOwnership.venueable.name : "All Venues"}
        </Button>
      )}
    />
  );
};

export default MarketingVenueSelector;
